/* eslint-disable react/self-closing-comp */
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import ProfileBanner from '../../components/profile-banner/profile-banner.component';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../configuration';
import { fetchProfile } from '../../redux/features/auth/slice';
import { useBlockerHook } from '../../hooks/use-blocker/useBlocker';
import WarningUpdateProfile from '../../components/warning-update-profile/warning-update-profile.component';
import { HandCoins, Lock } from 'lucide-react';
import { totalReciveDonate } from '../../api';
import dayjs from 'dayjs';
import RequestUnlockDonate from '../../components/request-unlock-donate/request-unlock-donate.component';
import Timeline from './components/Timeline';
import Group from './components/Group';
import WithdrawalHistory from './components/WithdrawalHistory';
import DepositHistory from './components/DepositHistory';
import UserSetting from '../user-setting/user-setting';
import Wallet from './components/Wallet';
import { useLocation, useNavigate } from 'react-router-dom';
import { buildProfileSlug } from '../../utils/profileSlug';

export const tabLabels = {
  followers: 'Top tương tác',
  receives: 'Top Receives',
  donator: 'Top Donator',
  'withdrawal-history': 'Lịch sử quyết toán thù lao',
  'deposit-history': 'Lịch sử nạp số dư',
};
export const ProfilePage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const location = useLocation();
  const profile = useSelector(
    (state: RootState) => state.features.auth.profile
  );
  const [activeTab, setActiveTab] = useState('timeline');
  const { showPrompt, setShowPrompt } = useBlockerHook({
    shouldBlock: !profile?.isUpdateProfile,
    shouldUnblock: false,
    disable: false,
  });

  // Chủ động nhắc hoàn thiện ngay khi vào trang cá nhân của mình (không đợi rời trang).
  useEffect(() => {
    if (profile && !profile.isUpdateProfile) {
      setShowPrompt(true);
    }
  }, [profile?.isUpdateProfile]);

  useEffect(() => {
    const { search } = window.location;
    const urlParams = new URLSearchParams(search);
    const openProfile = urlParams.get('open-profile');
    if (openProfile === 'true') {
      dispatch(fetchProfile());
    }
  }, []);

  // Đồng bộ tab theo URL (?tab=...). Phụ thuộc location.search — trước đây phụ
  // thuộc [activeTab] nên khi đang ở /profile bấm menu đổi tab (chỉ đổi query,
  // không remount) thì effect không chạy lại → tab không đổi.
  useEffect(() => {
    const tabFromUrl = new URLSearchParams(location.search).get('tab');
    setActiveTab(tabFromUrl || 'timeline');
  }, [location.search]);

  // Trang cá nhân của mình có URL riêng để chia sẻ: /profile → /user/{handle của mình}.
  // Ưu tiên username tuỳ chỉnh (dạng sạch), nếu chưa có thì {tên}-{id} (không nhét email vào URL).
  useEffect(() => {
    if (location.pathname !== '/profile' || !profile) return;
    const uname = (profile.username || '').toLowerCase();
    const clean = /^[a-z0-9_]{3,30}$/.test(uname);
    const canonical = clean
      ? uname
      : profile.sequenceId
      ? buildProfileSlug(profile.fullname, profile.sequenceId)
      : '';
    // Giữ nguyên query (?tab=settings…) để link cũ /profile?tab=... không rớt tab.
    if (canonical) navigate(`/user/${canonical}${location.search}`, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search, profile?.username, profile?.sequenceId]);

  const handleUpdateProfileSuccess = async () => {
    await dispatch(fetchProfile());
  };

  if (!profile) {
    return null;
  }
  const changeTag = (tab) => {
    setActiveTab(tab);
    navigate(`?tab=${tab}`);
  };
  const { username, description } = profile;

  return (
    <div className="w-full max-lg:-m-2.5 bg-white dark:bg-dark2">
      <Helmet>
        <title>{username || ''} - Cab</title>
        <meta name="description" content={description} />
      </Helmet>
      <WarningUpdateProfile
        profile={profile}
        visible={showPrompt}
        onClose={() => setShowPrompt(false)}
      />
      <ProfileBanner
        tabActive={activeTab}
        profile={profile}
        onUpdateSuccess={handleUpdateProfileSuccess}
        changeTab={changeTag}
      />

      <Timeline changeTab={changeTag} tabActive={activeTab} profile={profile} />
    </div>
  );
};
